<template>
    <div>
        <h1 class="h4 mb-3 text-gray-800">
            {{ $t("Concessão de Programa Social") }}
        </h1>

        <form @submit.prevent="submit" ref="addItem">
            <div class="row">
                <form-select
                    v-model="item.pessoas"
                    :multiple="true"
                    label="Usuário(s)"
                    :itens="pessoas"
                    :required="true"
                />

                <form-select
                    v-model="item.programa_social_id"
                    label="Programa Social"
                    :itens="programas"
                    :required="true"
                    @input="setValor"
                    ajuda="Se o item que você procura não for
encontrado nas opções abaixo você deve cadastrar na página de gestão de Programas Sociais ou solicitar o cadastro a quem tem permissões para realizar a ação"
                />

                <form-calendar
                    v-model="item.data_inicial"
                    grid="2"
                    label="Data de Início"
                    :required="true"
                />

                <form-calendar
                    v-model="item.data_final"
                    grid="2"
                    label="Data de Final"
                />

                <form-input
                    v-model="item.valor"
                    grid="4"
                    inputGroup="true"
                    btnText="R$"
                    :type="'number'"
                    label="Valor"
                />

                <form-textarea-editor
                    v-model="item.descricao"
                    grid="12"
                    label="Situação Identificada"
                    :required="true"
                />
            </div>

            <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            item: {
                valor: "",
            },
            programas: {},
        };
    },
    computed: {
        pessoas() {
            let pessoas = this.familia.familiares ?? [];

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
    },
    mounted() {
        this.getProgramasSociais();
    },
    methods: {
        getProgramasSociais() {
            axios.get(`api/dashboard/get/programassociais`).then((response) => {
                this.programas = response.data;
            });
        },
        setValor(value) {
            this.programas.filter((item) => {
                if (value == item.id && item.valor != null) {
                    this.item.valor = item.valor;
                } else {
                    this.item.valor = "";
                }
            });
        },
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            // if (this.item.data_inicial) {
            //     this.item.data_inicial = moment(
            //         this.item.data_inicial,
            //         "YYYY-MM-DD"
            //     ).format("YYYY-MM-DD");
            // }
            this.item.familia_id = this.familia.id;

            axios
                .post("api/dashboard/programasocial/beneficiarios", this.item)
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("voltar");
                    this.$emit("reload");
                });
        },
    },
};
</script>

<style></style>
